import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, signOut: () => {}, setUser: () => {} });

export function AuthProvider({ children }) {
  const initialUser = (typeof window !== "undefined" && window.location.hash?.includes("session_id="))
    ? null
    : undefined;
  const [user, setUser] = useState(initialUser);
  const fetchedRef = useRef(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  const signOut = useCallback(() => {
    api.post("/auth/logout").catch(() => {}).finally(() => setUser(null));
  }, []);

  // Initial /me fetch (only when user state is unknown)
  useEffect(() => {
    if (fetchedRef.current || user !== undefined) return;
    fetchedRef.current = true;
    refresh();
  }, [refresh, user]);

  return (
    <AuthContext.Provider value={{ user, loading: user === undefined, refresh, setUser, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
